module.exports = __webpack_public_path__ + "static/img/prizeo-logo.efe081c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/prizeo/imgs/prizeo-logo.png
// module id = 2104
// module chunks = 0